import { render } from "./ScrollPane.vue?vue&type=template&id=86e665ac&scoped=true"
import script from "./ScrollPane.vue?vue&type=script&lang=js"
export * from "./ScrollPane.vue?vue&type=script&lang=js"

import "./ScrollPane.vue?vue&type=style&index=0&id=86e665ac&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86e665ac"]])

export default __exports__